var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "root", staticClass: "querysummary" }, [
    _vm._v("\n\tResults for: "),
    _c(
      "span",
      {
        staticClass: "small text-muted content",
        attrs: { title: _vm.summary },
      },
      [_vm._v(_vm._s(_vm.summary.substr(0, 1000)))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }